import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './device-truck-implement.reducer';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import DoNotShowInProduction from 'app/shared/components/do-not-show-in-production/do-not-show-in-production.component';

export const DeviceTruckImplementDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const deviceTruckImplementEntity = useAppSelector(state => state.deviceTruckImplement.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="deviceTruckImplementDetailsHeading">
          <Translate contentKey="fleetSenseApp.deviceTruckImplement.detail.title">DeviceTruckImplement</Translate>
        </h2>
        <dl className="jh-entity-details">
          <DoNotShowInProduction>
            <dt>
              <span id="id">
                <Translate contentKey="global.field.id">ID</Translate>
              </span>
            </dt>
            <dd>{deviceTruckImplementEntity.id}</dd>
          </DoNotShowInProduction>
          <dt>
            <span id="serial">
              <Translate contentKey="fleetSenseApp.deviceTruckImplement.serial">Serial</Translate>
            </span>
          </dt>
          <dd>{deviceTruckImplementEntity.serial}</dd>
          <dt>
            <span id="firmware">
              <Translate contentKey="fleetSenseApp.deviceTruckImplement.firmware">Firmware</Translate>
            </span>
          </dt>
          <dd>{deviceTruckImplementEntity.firmware}</dd>
          <dt>
            <Translate contentKey="fleetSenseApp.deviceTruckImplement.device">Device</Translate>
          </dt>
          <dd>{deviceTruckImplementEntity.device ? deviceTruckImplementEntity.device.model : ''}</dd>
          <dt>
            <Translate contentKey="fleetSenseApp.deviceTruckImplement.truckImplement">Truck Implement</Translate>
          </dt>
          <dd>{deviceTruckImplementEntity.truckImplement ? deviceTruckImplementEntity.truckImplement.licensePlate : ''}</dd>
          <dt>
            <span id="imei">
              <Translate contentKey="fleetSenseApp.deviceTruckImplement.imei">Imei</Translate>
            </span>
          </dt>
          <dd>{deviceTruckImplementEntity.imei}</dd>
          <dt>
            <span id="iccid">
              <Translate contentKey="fleetSenseApp.deviceTruckImplement.iccid">Iccid</Translate>
            </span>
          </dt>
          <dd>{deviceTruckImplementEntity.iccid}</dd>
        </dl>
        <Button onClick={() => props.history.goBack()} replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/device-truck-implement/${deviceTruckImplementEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default DeviceTruckImplementDetail;
